import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from '@wearesection/raise-ui/atoms';


function ReactRenderContainerBlock() {
	const raiseContainerBlocks = Array.from( document.querySelectorAll( '.raise-container' ) ) as HTMLElement[];
	raiseContainerBlocks?.length > 0 &&
		raiseContainerBlocks.forEach( ( element: HTMLElement ) => {
			element.classList.remove( 'raise-container' );
            const eleClassName = element?.getAttribute( 'class' ).replace('raise-container','') as string;
			const htmlContent = element?.innerHTML;
			ReactDOM.render( <Container className={ eleClassName }>
                <div dangerouslySetInnerHTML={ { __html: htmlContent } } />
            </Container>, element );
		} );
}

export default ReactRenderContainerBlock;
